import icon from '@/assets/icon.png'
import { contact_path, privacy_path, root_path, terms_path } from '@/lib/routes'
import { Link, usePage } from '@inertiajs/react'
import { motion } from 'motion/react'
import { ReactNode } from 'react'
import AppearanceToggleDropdown from './appearance-dropdown'

export function Footer() {
  const { url } = usePage()
  return (
    <footer className="flex w-full items-center justify-center">
      <div className="container flex w-full flex-col items-center justify-between gap-3 p-4 py-12 text-sm whitespace-nowrap md:flex-row">
        <div className="flex items-center gap-1">
          <Link href={root_path()}>
            <img src={icon} className="size-8" alt="picchat.ai" />
          </Link>
          <div className="flex flex-col items-start justify-start">
            <div className="text-foreground/60 text-xs">
              by&nbsp;
              <a
                className="text-foreground/60 text-xs font-semibold tracking-wide uppercase"
                target="_blank"
                href="https://nyaggah.com"
              >
                Nyaggah
              </a>
            </div>
          </div>
        </div>

        <div className="text-muted-foreground">
          Copyright &copy; {new Date().getFullYear()}
        </div>
        <nav className="flex flex-row items-center justify-center gap-3 p-1 text-sm md:items-center">
          <motion.div
            variants={{
              hidden: { opacity: 0, y: 20 },
              visible: {
                opacity: 1,
                y: 0,
                transition: { duration: 0.6, ease: 'easeOut', delay: 0.2 },
              },
            }}
          >
            <AppearanceToggleDropdown />
          </motion.div>
          {footerLinks.map((link, index) => (
            <Link
              key={index}
              className="text-muted-foreground hover:text-foreground data-[active=true]:text-foreground"
              href={link.href}
              data-active={url === link.href}
            >
              {link.text}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  )
}

// export const socialLinks: SocialLink[] = [
//   {
//     href: 'https://x.com/nyaggah',
//     icon: <SiX />,
//     name: '@nyaggah',
//   },
//   {
//     href: 'https://bsky.app/profile/nyaggah.bsky.social',
//     icon: <SiBluesky />,
//     name: '@nyaggah',
//   },
//   {
//     href: 'https://www.youtube.com/@nyaggah',
//     icon: <SiYoutube />,
//     name: '@nyaggah',
//   },
//   // {
//   //   href: "https://instagram.com",
//   //   icon: <SiInstagram />,
//   //   name: "@instagram",
//   // },
//   // {
//   //   href: "https://www.threads.net/",
//   //   icon: <SiThreads />,
//   //   name: "@threads",
//   // },
//   // {
//   //   href: "https://linkedin.com",
//   //   icon: <SiLinkedin />,
//   //   name: "@linkedin",
//   // },
// ]

export interface NavLink {
  text: ReactNode
  href: string
}

export const footerLinks: NavLink[] = [
  // {
  //   text: "Windows",
  //   href: "/downloads/windows",
  // },
  // {
  //   text: "Linux",
  //   href: "/downloads/linux",
  // },
  {
    text: 'Privacy',
    href: privacy_path(),
  },
  {
    text: 'Terms',
    href: terms_path(),
  },
  {
    text: 'Contact',
    href: contact_path(),
  },
]
